/**
 * component-quantity.js
 * <quantity-input> — the −/+ stepper around a number input.
 *
 * EXTRACTED FROM component-product-form.js.
 *
 * It lived there, but <quantity-input> is used in THREE places: the product
 * form, the cart drawer, and the cart page. component-product-form.js is only
 * loaded by main-product.liquid, so on /cart and in the drawer the element was
 * never defined and the −/+ buttons were inert. Typing into the number field
 * still worked, which is why it looked fine — but on mobile the buttons are the
 * primary control, and they did nothing at all.
 */
(function () {
  'use strict';

  // Single-execution guard — see component-drawer.js. Loaded by several
  // sections, and two <script> tags with the same src DO both execute.
  if (window.__themeQuantityLoaded) return;
  window.__themeQuantityLoaded = true;

  class QuantityInput extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-quantity-input]');
      if (!this.input) return;

      this.addEventListener('click', (event) => {
        const decrease = event.target.closest('[data-quantity-decrease]');
        const increase = event.target.closest('[data-quantity-increase]');
        if (!decrease && !increase) return;

        const step = increase ? 1 : -1;

        // NOT `parseInt(min) || 1`. Cart rows render min="0" so a customer can
        // step the last unit down to zero to remove the line; `0 || 1` is 1,
        // which silently made the floor 1 and made that impossible.
        const parsedMin = parseInt(this.input.min, 10);
        const min = Number.isNaN(parsedMin) ? 1 : parsedMin;

        const parsedMax = parseInt(this.input.max, 10);
        const max = Number.isNaN(parsedMax) ? Infinity : parsedMax;

        const current = parseInt(this.input.value, 10);
        const base = Number.isNaN(current) ? min : current;
        const next = Math.min(max, Math.max(min, base + step));

        if (next === current) return;

        this.input.value = next;
        // `change` is what listeners bind to; setting .value does not fire it.
        this.input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
  }

  if (!customElements.get('quantity-input')) customElements.define('quantity-input', QuantityInput);
})();
